import React from "react";

export default {
  pedregal: {
    url_youtube: "https://youtu.be/a7jKgFVlN4o",
    url_ubicacion: "https://goo.gl/maps/2t1A8njN8p4EK2zQ7",
    url_tienda: "http://pedregalplusdos.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "Acceso sobre Av. Huayacán",
    texto2: "Lote Base de 225m²",
    info1:
      "Este desarrollo se localiza en una zona rodeada de reserva urbana, de un alto crecimiento y proyección urbanística. Cuenta con una excelente conectividad, ya que la Av. Huayacán llega directamente al corazón de Cancún hasta las afueras de la ciudad",
    info2:
      "Av. Huayacán es una avenida vertiente de las zonas con mayor desarrollo residencial comunitario en Cancún, tanto residencial como comercial. Es una zona jóven con mucho movimiento y vida, varias opciones de restaurantes, cerca de escuelas y universidades.",
    color: "linear-gradient(180deg, #194c69, #194c69)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/PEDREGAL/pedregal%20calle%202.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/PEDREGAL/pedregal%20calle.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/PEDREGAL/pedregal%20caseta%20de%20noche.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/PEDREGAL/pedregal%20caseta.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/PEDREGAL/pedregal%20plus%20caseta.png",
    ],
    amenidades: [
      "1.png",
      "2.png",
      "3.png",
      "4.png",
      "5.png",
      "6.png",
      "7.png",
      "8.png",
      "9.png",
      "10.png",
    ],
    InfLista: [],
    color_txt: "#fff",
  },
  barcelona: {
    url_youtube: "https://youtu.be/gFwfUXU1Ohc",
    url_ubicacion: "https://goo.gl/maps/3zmnWyaS2hRtVYvHA",
    url_tienda: "http://21.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "Acceso sobre Av. Huayacán",
    texto2: "Lote Base de 225m²",
    info1:
      "Es un excelente desarrollo con conexión a una de las avenidas principales de Cancún, la AV. HUAYACÁN, gracias a su ubicación estratégica te encontrarás a tan solo minutos del centro, la zona hotelera, centros comerciales, aeropuerto internacional y de las playas más hermosas del caribe mexicano",
    info2: "",
    color: "linear-gradient(180deg, #04517c, #151f3a)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/BARCELONA/barcelona%20aerea%202.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/BARCELONA/barcelona%20aerea.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/BARCELONA/barcelona%20calle.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/BARCELONA/barcelona%20huayacan.png",
    ],
    amenidades: ["1.png", "2.png", "3.png", "4.png"],
    info_lista: [
      "A 10 min. del Aeropuerto",
      "A 10 min. de Zona Escolar",
      "A 10 min. de Centroos comerciales",
      "A 20 min. de Puerto Morelos",
      "A 20 min. de Punta Nizuk",
    ],
    color_txt: "#fff",
  },
  azaahy: {
    url_youtube: "https://youtu.be/S58e5A1NUBA",
    url_ubicacion: "https://goo.gl/maps/ww8kw2zbF4FWTGw19",
    url_tienda: "http://19.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A tan solo 20 min. de la playa",
    texto2: "Lote Base de 200m²",
    info1:
      "Te ofrece la más alta calidad de vida se pone al alcance de los residentes con un concepto único en su clase dedicado a la convivencia familiar, el cual le brindará vitalidad, alegría y convivio para una verdadera comunidad en contacto permanente con la naturaleza que rodea el desarrollo.",
    info2:
      "Te garantiza un lugar alegre brindándote lo necesario para también ser divertido, un lugar para reunirnos con nuestra familia y generar conexiones con personas que también quieren una vida plena y con sentido de apoyo a su comunidad es por esto que las amenidades son los sitios ideales para lograrlo.",
    color: "linear-gradient(180deg, #09478e, #072550)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20aerea.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20alberca%202.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20alberca%203.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20alberca%20etapa%201%202.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20alberca%20etapa%201.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20alberca.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20caseta.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20club.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20padel.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20palapa.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20palapas.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/AZAAHY/azaahy%20vestidores.png",
    ],
    amenidades: [
      "1.png",
      "2.png",
      "3.png",
      "4.png",
      "5.png",
      "6.png",
      "7.png",
      "8.png",
      "9.png",
      "10.png",
      "11.png",
      "12.png",
      "13.png",
    ],
    InfLista: [],
    color_txt: "#fff",
  },
  terramillpa: {
    url_youtube: "https://youtu.be/kWh5DRX37SI",
    url_ubicacion: "https://goo.gl/maps/CFHM6aXRgWZM8ABh6",
    url_tienda: "http://terramilpa.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A tan solo 20 min. de Cancún",
    texto2: "Lote Base de 270m²",
    info1:
      "'Desde que entras a este desarrollo podrás estar en contacto con la naturaleza, desde conocer la fabulosa vegetación, que se encuentre en la zona, hasta escuchar los pájaros cantar'. Su concepto campestre y ecológico es ideal para casas de descanso y cambiar la rutina de la ciudad. Disfruta de estar rodeado de enormes áreas verdes. ",
    info2:
      "Los terrenos en este desarrollo se basan en restricciones para la conservación del medio ambiente, en donde podrás construir en un 65% del área total y construir hasta 3 niveles, para mantener siempre el ambiente verde & natural del desarrollo. ",
    color: "linear-gradient(180deg, #70b530, #70b530)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/TERRA/terra%20alberca%20atardecer.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/TERRA/terra%20alberca%20frente.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/TERRA/terra%20alberca.png",
      "https://amistad.z22.web.core.windows.net/tiendaamistad/terramillpa/amen4.png",
      "https://amistad.z22.web.core.windows.net/tiendaamistad/terramillpa/amen5.png",
    ],
    amenidades: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/TERRA/terra%20amenidades.png",
      "2.png",
      "3.png",
      "4.png",
      "5.png",
      "6.png",
      "8.png",
      "9.png",
      "10.png",
      "11.png",
      "12.png",
      "13.png",
      "14.png",
      "15.png",
    ],
    InfLista: [],
    color_txt: "#fff",
  },
  mayorales: {
    url_youtube: "https://www.youtube.com/watch?v=uoSCj6U1j4w",
    url_ubicacion: "https://goo.gl/maps/nsHJVXx7Stk2KfvS6",
    url_tienda: "http://mayorales.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A 20 min. de la Playa",
    texto2: "Lote Base de 225m²",
    info1:
      "Todo ser vivo necesita de un terreno donde desarollarse, La flora, la fauna, e incluso los seres humanos, necesitamos de un espacio para crecer. Y que mejor lugar que en el caribe mexicano. Imagina ser dueño de un terreno en el paraíso tropical, ES POSIBLE, aprovecha ahora PRECIOS DE PREVENTA.",
    info2:
      "Ubicada a 10 minutos del aeropuerto, en la zona con mayor crecimiento y plusvalía de Cancún, cerca de vialidades importantes, la av. Huayacán.",
    color: "linear-gradient(180deg, #144b4c, #063031)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/MAYORALES/mayorales%201.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/MAYORALES/mayorales%202.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/MAYORALES/mayorales%203.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/MAYORALES/mayorales%204.png",
    ],
    amenidades: [],
    InfLista: "<li></li>",
    color_txt: "#fff",
  },
  anikwa: {
    url_youtube: "https://youtu.be/DPfNBiR-L78",
    url_ubicacion: "https://goo.gl/maps/YSSMb5KZhunauN1J9",
    url_tienda: "http://anikwa.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A tan solo 5 min. del Super Gutierrez",
    texto2: "Lote Base de 198m²",
    info1:
      "ANIKWA es más que un desarrollo, ya que además de darle una oportunidad de inversión y vivienda a nuestros futuros habitantes que buscan un lugar seguro, accesible y con oportunidad de mejorar su calidad de vida, Anikwa te muestra su inspiración cultural.",
    info2:
      "Disfruta de un oasis en el desierto, Anikwa tiene todo para ser la mejor inversión para iniciar un patrimonio ubicado en la zona dorada de buenaventura. Disfruta de las Amenidades que ANIKWA tiene para que disfrutes con toda tu familia con toda la seguridad y confianza en todo momento.",
    color: "linear-gradient(180deg, #711b13, #4c1b13)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ANIKWA/anikwa%20caseta.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ANIKWA/anikwa%20dron.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ANIKWA/anikwa%20lago.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ANIKWA/anikwa%20palapa.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ANIKWA/anikwa%20vestidores.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ANIKWA/anikwa%20alberca.png",
    ],
    amenidades: [],
    InfLista: [],
    color_txt: "#fff",
  },
  senderos: {
    url_youtube: "https://youtu.be/yj_gca86Wyc",
    url_ubicacion: "https://g.page/Senderosamistad?share",
    url_tienda: "http://senderos.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A 51 min. del Centro de Monclova",
    texto2: "Lote Base de 250m²",
    info1:
      "Además de ser tu mejor opción por la ubicación que tiene el desarrollo, Senderos te ofrece la mejor forma para invertir en un patrimonio para tus hijos. Algo que distingue a Senderos de otros desarrollos es la cercanía al centro de Monclova, vivir en Senderos te ofrece una de las mejores ubicaciones con supermercados, dulcerías, parques, escuelas, etc.",
    info2: "",
    info3: "Si inviertes hoy en Senderos ganas: ",
    color: "linear-gradient(180deg, #007056, #007056)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/Senderos/senderos%201.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/Senderos/senderos%202.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/Senderos/senderos%203.png",
    ],
    amenidades: ["1.png"],
    info_lista: [
      "Certeza jurídica,",
      "Excelentes dimensiones",
      "Precioes Accesibles",
      "Libre espacio de convivencia",
      "Excelente Ubicación",
    ],
    color_txt: "#fff",
  },
  frey: {
    url_youtube: "https://youtu.be/JIfQYS3xYlE",
    url_ubicacion: "https://goo.gl/maps/eKz8U4d12tYiAHHM8",
    url_tienda: "http://75.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A 20 min. de la Playa",
    texto2: "Lote Base de 225m²",
    info1:
      "¿Sueñas con tener un lugar donde vacacionar en el caribe mexicano? pero, ¿Qué tal sería ser el dueño de un pedacito de Tierra en el Carible? Planea tu propio espacio en este paraíso, esta tu gran oportunidad para invertir en una de las zonas con más rápido crecimiento en México.",
    info2:
      "Ubicado cerca de las playas más hermosas y paradisíacas del caribe mexicano, hará crecer el valor de tu dinero en un corto plazo. Su cercanía al aeropuerto te permitirá conectar con infraestructura de primer nivel conjunto con la hermosa flora y fauna de la zona.",
    color: "linear-gradient(180deg, #094b78, #121a31)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/FREY/frey%201.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/FREY/frey%202.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/FREY/frey%203.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/FREY/frey%204.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/FREY/frey%202.png",
    ],
    amenidades: [],
    InfLista: [],
    color_txt: "#fff",
  },
  asaurus: {
    url_youtube: "",
    url_ubicacion: "https://goo.gl/maps/Wnaun2EecfcyrFv77",
    url_tienda: "http://asaurus.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A 10 min. del centro de Mva",
    texto2: "Lote Base de 160m²",
    info1: (
      <>
        <b>INVIERTE</b> en una de las mejores zonas de la Ciudad de Monclova. Su
        excelente ubicación hace que la plusvalía de <b>ASAURUS</b> crezca de
        manera rápida. <br /> <br />
        Terrenos de 160m2 <br />
        <br /> <b>APROVECHA LOS PRECIOS DE PREVENTA</b>{" "}
      </>
    ),
    info2: (
      <>
        Ubicado sobre el libramiento Oriente de Monclova o 300m del monumento YO
        AMO MONCLOVA. <br />
        <br />
        <b>¡Descubre ASAURUS!</b>
      </>
    ),
    color: "linear-gradient(180deg, #0E1020, #243A5F)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ASAURUS/asaurus%20vista.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ASAURUS/asaurus%20caseta.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ASAURUS/asaurus%205.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ASAURUS/asaurus%204.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ASAURUS/asaurus%203.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ASAURUS/asaurus%20caseta.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ASAURUS/asaurus%20caseta%202.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/ASAURUS/asaurus%202.png",
    ],
    amenidades: [],
    InfLista: [],
    color_txt: "#fff",
  },
  orovaaly: {
    url_youtube: "",
    url_ubicacion: "https://maps.app.goo.gl/eT7SeNcnsq2FHmzv6",
    url_tienda: "http://orovaaly.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "",
    texto2: "Lote Base de 171m²",
    info1:
      "Descubre la tranquilidad en OROVAALY, donde cada espacio es un lienzo para construir tus sueños.",
    info2:
      "Orovaaly es un nuevo desarrollo ubicado a escasos metros del 8 de enero, con acceso a tans olo 600 metros de la Carretera 30, y a 4 minutos del corredor gastronomico",
    color: "linear-gradient(180deg, #000000, #000000)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/OROVAALY/orovaaly1.jpg",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/OROVAALY/orovaaly2.jpg",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/OROVAALY/orovaaly3.jpg",
    ],
    amenidades: [],
    InfLista: [],
    color_txt: "#fff",
  },
  yarinawi: {
    url_youtube: "",
    url_ubicacion: "https://maps.app.goo.gl/Q4cT6suA9u3YZQfx8",
    url_tienda: "http://yarinawi.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A 3 minutos de San buenaventura",
    texto2: "Lote Base de 160m²",
    info1:
      "YARINAKI te da la oportunidad de unvertir en un lugar seguro, con una excelente ubicación.",
    info2:
      "Además de ser una de las mejores opciones por su ubicación, Yarinawi te ofrece la mejor forma de invertir en tu futuro y en el de tu familia.Aprovecha ahora e invierte en una de las mejores ubicaciones, ya que Yarinawi se encuentre sobre la Carretera 30",
    color: "linear-gradient(180deg, #094b78, #121a31)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/YARINAWI/yarinawi1.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/YARINAWI/yarinawi3.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/YARINAWI/yarinawi3_1.png",
    ],
    amenidades: [],
    InfLista: [],
    color_txt: "#fff",
  },
  sanpedro: {
    url_youtube: "https://youtu.be/HvSi9rIgiqU",
    url_ubicacion: "https://maps.app.goo.gl/maojdQP4WyoQwUNo8",
    url_tienda: "https://sanpedro.amistadbienesraices.com/",
    logo: "logo.png",
    imagen_tienda: "tienda.png",
    texto1: "A 25 min de la playa",
    texto2: "Lote Base de 182m²",
    info1:
      "Este desarrollo te ofrece la oportunidad de invertir en terrenos con una ubicación privilegiada.",
    info2:
      "Con Acceso de la carretera Cancún - Mérida y con Central de Carga, este proyecto promete un retorno de inversión atractivo y un entorno tranquilo ideal para construir el hogar de tus sueños o aprovechar las oportunidades de crecimiento de la zona.San Pedro es una opción perfecta tanto para aquellos que buscan calidad de vida como para los que desean invertir en el Futuro",
    color: "linear-gradient(180deg, #094b78, #121a31)",
    imagenes: [
      "https://abrmain.blob.core.windows.net/desarrollos-landing/SANPEDRO/spedro1.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/SANPEDRO/spedro2.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/SANPEDRO/spedro3.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/SANPEDRO/spedro4.png",
      "https://abrmain.blob.core.windows.net/desarrollos-landing/SANPEDRO/spedro5.png",
    ],
    amenidades: [],
    InfLista: [],
    color_txt: "#fff",
  },
  // serenavi: {
  //   url_youtube: "",
  //   url_ubicacion: "https://maps.app.goo.gl/487vgMAhxuNWsSkRA",
  //   url_tienda: "http://orovaaly.amistadbienesraices.com/",
  //   logo: "logo.png",
  //   imagen_tienda: "tienda.png",
  //   texto1: "",
  //   texto2: "Lote Base de 160m²",
  //   info1:
  //     "Haz que tus sueños se hagan realidad en SERENAVI, un nuevo desarrollo en Lamadrid.",
  //   info2:
  //     "Descubre la combinación perfecta de tranquilidad y de comodidad Además de ser una de las mejores opciones por su ubicación, Serenavi te ofrece la mejor forma de invertir en tu futuro y en el de tu familia.",
  //   color: "linear-gradient(180deg, #094b78, #121a31)",
  //   imagenes: [
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/SERENAVI/serenavi.jpg",
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/SERENAVI/serenavi2.png",
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/SERENAVI/serenavi3.png",
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/SERENAVI/serenavi4.png",
  //   ],
  //   amenidades: [],
  //   InfLista: [],
  //   color_txt: "#fff",
  // },
  // cataluna: {
  //   url_youtube: "https://youtu.be/HvSi9rIgiqU",
  //   url_ubicacion: "https://maps.app.goo.gl/E7MTK7evVtPCTJJ48",
  //   url_tienda: "https://95.amistadbienesraices.com/",
  //   logo: "logo.png",
  //   imagen_tienda: "tienda.png",
  //   texto1: "A 17 minutos de la playa",
  //   texto2: "Lote Base de 182m²",
  //   info1:
  //     "Es una excelente opción de Inversión única en Cancún, ubicado estratégicamente sobre la Carretera Federal Cancún - Mérida, a pocos minutos de la Av. Huayacán, una de las zonas de mayor plusvalía en la Ciudad.",
  //   info2:
  //     "Este desarrollo ofrece lotes con acceso privado, ideal para quienes buscan un lugar tranquilo y seguro. Además, contará con increíbles amenidades como caseta de acceso, casa club, gimnasio, alberca, cenote, entre muchas otras, garantizando tanto tu confort como seguridad para ti y tu familia",
  //   color: "linear-gradient(180deg, #094b78, #121a31)",
  //   imagenes: [
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/CATALU%C3%91A/catalu%C3%B1a%20alberca.png",
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/CATALU%C3%91A/catalu%C3%B1a%20canchas.png",
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/CATALU%C3%91A/catalu%C3%B1a%20caseta.png",
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/CATALU%C3%91A/catalu%C3%B1a%20desmonte.png",
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/CATALU%C3%91A/catalu%C3%B1a%20noche.png",
  //     "https://abrmain.blob.core.windows.net/desarrollos-landing/CATALU%C3%91A/catalu%C3%B1a%20padel.png",
  //   ],
  //   amenidades: [],
  //   InfLista: [],
  //   color_txt: "#fff",
  // }
  // "sanan": {
  //    "url_youtube": "https://www.youtube.com/watch?v=xgjqpr8rq8U",
  //    "url_ubicacion": "https://goo.gl/maps/mFpAMZ9YXj9TknM4A",
  //    "url_tienda": "http://sanantonio.amistadbienesraices.com/",
  //    "logo": "logo.png",
  //    "imagen_tienda": "tienda.png",
  //    "texto1": "A 10 min. de San Buena",
  //    "texto2": "Lote Base de 2225m²",
  //    "info1": <><b>SAN ANTONIO</b> es un excelente desarrollo con conexión a la ciudad de Monclova (8km) y San Buenaventura (9km),
  //       ideal para invertir para el futuro. <br /><br /> Podrás accesar al desarrollo sobre la Carretera Federal por "La bascula". </>,
  //    "info2": <>Aprovecha los precios de <b>PREVENTA </b> y comienza a invertir hoy mismo. <br /><br /> Terrenos de 189m2
  //       <br /><br /> <b>¡Descubre San Antonio!</b></>,
  //    "color": "linear-gradient(180deg, #F7E3BD, #F7E3BD)",
  //    "imagenes": ["amen.png", "amen2.png", "amen3.png", "amen4.png"],
  //    "amenidades": [],
  //    "InfLista": [],
  //    "color_txt": "#9d2e1b"
  // }
};
